{
    "DatePattern": "DD-MMM-YYYY",
    "PrettyDatePattern": "MMM Do, YYYY",
    "NAME": "Date"
}